import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueClipboard from "vue-clipboard2";
import 'leaflet/dist/leaflet.css';

Vue.config.productionTip = false
Vue.config.devtools = true;
new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard);
